import LoginContainer from "../../../Components/Authentication/Login";

const Login = () => {
  return <LoginContainer />;
};

export default Login;
